"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "Instagram" | "LinkedIn" */
    ariaLabel: string;
    /** Detected variants: "fab fa-facebook-f" | "fab fa-twitter" | "fab fa-instagram" | "fab fa-linkedin-in" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.clinics" */
    href: string;
};
export type HomeFifteenFooterSectionGeneratedProps = {
    /** Default: "LET’S US TALK" */
    footerDiv0Div0H20H2Text?: ReactNode;
    footerDiv0Div0H20H2Visible?: boolean;
    footerDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "TOGETHER" */
    footerDiv0Div0H20Span0SpanText?: ReactNode;
    footerDiv0Div1Div0ClassName?: string;
    /** Default: "logo" */
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-15.svg" */
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "We are a trusted diagnostic laboratory offering accurate tests, advanced technology, and patient-focused care." */
    footerDiv0Div1Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "Quick Links" */
    footerDiv0Div1Div0Div1Div0H20H2Text?: ReactNode;
    footerDiv0Div1Div0Div1Div0H20H2Visible?: boolean;
    footerDiv0Div1Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Info@example.com" */
    footerDiv0Div1Div0Div2Div0Div0P0PText?: ReactNode;
    /** Default: "tel:+15456564578" */
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkHref?: string;
    /** Default: "+1 54565 64578" */
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkText?: ReactNode;
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkVisible?: boolean;
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormVisible?: boolean;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    /** Default: "Subscribe" */
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonAriaLabel?: string;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonVisible?: boolean;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Input0InputPlaceholder?: string;
    /** Default: "Subscribe to get new updates" */
    footerDiv0Div1Div0Div2Div0Div1P0PText?: ReactNode;
    /** Default: "Copyright © 2026" */
    footerDiv0Div2Div0P0PText?: ReactNode;
    /** Default: ". All Rights Reserved" */
    footerDiv0Div2Div0P0PText2?: ReactNode;
    /** Default: "#" */
    footerDiv0Div2Div0P0Link0LinkHref?: string;
    /** Default: "Doccure" */
    footerDiv0Div2Div0P0Link0LinkText?: ReactNode;
    footerDiv0Div2Div0P0Link0LinkVisible?: boolean;
    footerDiv0Div2Div0P0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div2Div0P0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-4.svg" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-1.svg" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    footerImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/footer-shadow-1.svg" */
    footerImageWithBasePath2ImageSrc?: string;
    footerImageWithBasePath2ImageVisible?: boolean;
    footerImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    footerLink0LinkHref?: string;
    footerLink0LinkVisible?: boolean;
    footerLink0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Start" */
    footerLink0P0PText?: ReactNode;
    /** Default: "Booking" */
    footerLink0P0Span0SpanText?: ReactNode;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionDivs: FooterSectionDivsItem[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkVisible?: boolean;
    footerSectionDivsLinkRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFifteenFooterSectionGenerated: FC<HomeFifteenFooterSectionGeneratedProps> = ({
    footerDiv0Div0H20H2Text = "LET’S US TALK",
    footerDiv0Div0H20H2Visible,
    footerDiv0Div0H20H2Renderer,
    footerDiv0Div0H20H2Props,
    footerDiv0Div0H20Span0SpanText = "TOGETHER",
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "logo",
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-15.svg",
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    footerDiv0Div1Div0Div0Div0Div1P0PText = "We are a trusted diagnostic laboratory offering accurate tests, advanced technology, and patient-focused care.",
    footerDiv0Div1Div0Div1Div0H20H2Text = "Quick Links",
    footerDiv0Div1Div0Div1Div0H20H2Visible,
    footerDiv0Div1Div0Div1Div0H20H2Renderer,
    footerDiv0Div1Div0Div1Div0H20H2Props,
    footerDiv0Div1Div0Div2Div0Div0P0PText = "Info@example.com",
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkHref = "tel:+15456564578",
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkText = "+1 54565 64578",
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkVisible,
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkRenderer,
    footerDiv0Div1Div0Div2Div0Div0P1Link0LinkProps,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonAriaLabel = "Subscribe",
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonVisible,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonRenderer,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonProps,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv0Div1Div0Div2Div0Div1P0PText = "Subscribe to get new updates",
    footerDiv0Div2Div0P0Link0LinkHref = "#",
    footerDiv0Div2Div0P0Link0LinkText = "Doccure",
    footerDiv0Div2Div0P0Link0LinkVisible,
    footerDiv0Div2Div0P0Link0LinkRenderer,
    footerDiv0Div2Div0P0Link0LinkProps,
    footerDiv0Div2Div0P0PText = "Copyright © 2026",
    footerDiv0Div2Div0P0PText2 = ". All Rights Reserved",
    footerImageWithBasePath0ImageAlt = "",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/round-element-4.svg",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/round-element-1.svg",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerImageWithBasePath2ImageAlt = "shadow",
    footerImageWithBasePath2ImageSrc = "/Templates/Doccure/img/icons/footer-shadow-1.svg",
    footerImageWithBasePath2ImageVisible,
    footerImageWithBasePath2ImageRenderer,
    footerImageWithBasePath2ImageProps,
    footerLink0LinkHref = "#",
    footerLink0LinkVisible,
    footerLink0LinkRenderer,
    footerLink0LinkProps,
    footerLink0P0PText = "Start",
    footerLink0P0Span0SpanText = "Booking",
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormVisible,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormRenderer,
    footerDiv0Div1Div0Div2Div0Div1Div0Form0FormProps,
    liLink0LinkProps,
    linkLinkProps,
    footerDiv0Div1Div0ClassName,
    footerSectionDivs,
    footerSectionUls,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionDivsLinkVisible,
    footerSectionDivsLinkRenderer,
    footerSectionDivsLinkProps,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
}) => {
    return (
        <footer className="footer-fifteen">
            <div className="container">
                <div className="footer-content">
                    {renderNode(footerDiv0Div0H20H2Visible, footerDiv0Div0H20H2Renderer, (
                        <h2 className="footer-text" {...(footerDiv0Div0H20H2Props ?? {})}>
                            {" "}
                            {footerDiv0Div0H20H2Text}
                            <span>{footerDiv0Div0H20Span0SpanText}</span>
                            {" "}
                        </h2>
                    ))}
                </div>
                <div className="footer-top">
                    <div className={footerDiv0Div1Div0ClassName ?? "row row-gap-sm-5 row-gap-5"}>
                        <div className="col-xl-4 col-lg-4 col-md-12">
                            <div className="footer-widget footer-about">
                                <div className="footer-logo">
                                    {renderNode(footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageVisible, footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageAlt} {...(footerDiv0Div1Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="footer-about-content">
                                    <p>{footerDiv0Div1Div0Div0Div0Div1P0PText}</p>
                                    <div className="social-icon">
                                        {renderCollectionNode(
                                            footerSectionDivs,
                                            (item: FooterSectionDivsItem) => (
                                                renderItemNode(footerSectionDivsLinkVisible, footerSectionDivsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} aria-label={item.ariaLabel} {...(typeof footerSectionDivsLinkProps === "function" ? footerSectionDivsLinkProps(item) : (footerSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                        <i className={item.className} />
                                                    </SmartLink>
                                                ))
                                            ),
                                            footerSectionDivsItemWrapper,
                                            footerSectionDivsRenderer
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                            <div className="footer-widget">
                                {renderNode(footerDiv0Div1Div0Div1Div0H20H2Visible, footerDiv0Div1Div0Div1Div0H20H2Renderer, (
                                    <h2 className="footer-title" {...(footerDiv0Div1Div0Div1Div0H20H2Props ?? {})}>{footerDiv0Div1Div0Div1Div0H20H2Text}</h2>
                                ))}
                                <ul className="footer-menu">
                                    {renderCollectionNode(
                                        footerSectionUls,
                                        (item: FooterSectionUlsItem) => (
                                            <li key={item.key}>
                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                    <SmartLink href={item.href} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </li>
                                        ),
                                        footerSectionUlsItemWrapper,
                                        footerSectionUlsRenderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                            <div className="footer-widget footer-end">
                                <div className="footer-mail">
                                    <p className="mail-text">{footerDiv0Div1Div0Div2Div0Div0P0PText}</p>
                                    <p className="mail-text ph-number">
                                        {renderNode(footerDiv0Div1Div0Div2Div0Div0P1Link0LinkVisible, footerDiv0Div1Div0Div2Div0Div0P1Link0LinkRenderer, (
                                            <SmartLink href={footerDiv0Div1Div0Div2Div0Div0P1Link0LinkHref} {...(footerDiv0Div1Div0Div2Div0Div0P1Link0LinkProps ?? {})}>{footerDiv0Div1Div0Div2Div0Div0P1Link0LinkText}</SmartLink>
                                        ))}
                                    </p>
                                </div>
                                <div className="footer-subscribe">
                                    <p>{footerDiv0Div1Div0Div2Div0Div1P0PText}</p>
                                    <div className="subscribe-input">
                                        {renderNode(footerDiv0Div1Div0Div2Div0Div1Div0Form0FormVisible, footerDiv0Div1Div0Div2Div0Div1Div0Form0FormRenderer, (
                                            <form action="#" {...(footerDiv0Div1Div0Div2Div0Div1Div0Form0FormProps ?? {})}>
                                                <input type="email" className="form-control" placeholder={footerDiv0Div1Div0Div2Div0Div1Div0Form0Input0InputPlaceholder} />
                                                {renderNode(footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonVisible, footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonRenderer, (
                                                    <button type="submit" className="btn-icon btn btn-primary-gradient" aria-label={footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonAriaLabel} {...(footerDiv0Div1Div0Div2Div0Div1Div0Form0Button0ButtonProps ?? {})}>
                                                        <i className="isax isax-arrow-right-1" />
                                                    </button>
                                                ))}
                                            </form>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="copyright">
                        <p className="mb-0">
                            {footerDiv0Div2Div0P0PText}
                            {" "}
                            {renderNode(footerDiv0Div2Div0P0Link0LinkVisible, footerDiv0Div2Div0P0Link0LinkRenderer, (
                                <SmartLink href={footerDiv0Div2Div0P0Link0LinkHref} className="footer-link" {...(footerDiv0Div2Div0P0Link0LinkProps ?? {})}>{footerDiv0Div2Div0P0Link0LinkText}</SmartLink>
                            ))}
                            {footerDiv0Div2Div0P0PText2}
                        </p>
                    </div>
                </div>
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="round-element-4" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="round-element-5" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath2ImageVisible, footerImageWithBasePath2ImageRenderer, (
                <SmartImage src={footerImageWithBasePath2ImageSrc} alt={footerImageWithBasePath2ImageAlt} className="shadow-1" {...(footerImageWithBasePath2ImageProps ?? {})} />
            ))}
            <span className="circle-element-1" />
            <span className="circle-element-2" />
            {renderNode(footerLink0LinkVisible, footerLink0LinkRenderer, (
                <SmartLink href={footerLink0LinkHref} className="start-booking" {...(footerLink0LinkProps ?? {})}>
                    <i className="isax isax-calendar-15" />
                    <p className="mb-0">
                        {footerLink0P0PText}
                        <span>{footerLink0P0Span0SpanText}</span>
                    </p>
                </SmartLink>
            ))}
        </footer>
    );
};

export default HomeFifteenFooterSectionGenerated;
